import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "x-dense" }
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3 title" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "d-flex align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_divider)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_form, {
      modelValue: _ctx.valid,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.valid) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, {
          "no-gutters": "",
          style: {"border":"1px #ededed solid","border-radius":"15px"},
          class: "pa-2"
        }, {
          default: _withCtx(() => [
            (_ctx.sepas.length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "4",
                  class: "mt-2 pr-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select_filled, {
                      modelValue: _ctx.selectedSepa,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedSepa) = $event)),
                        _ctx.onDocumentChanged
                      ],
                      items: _ctx.sepas,
                      "item-value": "id",
                      label: _ctx.title,
                      mandatory: true,
                      "hide-details": "auto",
                      "return-object": "",
                      readonly: _ctx.readonly,
                      density: "compact",
                      "item-title": (item) => item.displayName
                    }, null, 8, ["modelValue", "items", "label", "onUpdate:modelValue", "readonly", "item-title"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_col, {
              cols: _ctx.sepas.length ? 4 : 6,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.selectedSepa.displayName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSepa.displayName) = $event)),
                  label: "Nom",
                  rules: [_ctx.rules.notEmpty],
                  "hide-details": "auto",
                  readonly: _ctx.readonly,
                  density: "compact"
                }, null, 8, ["modelValue", "rules", "readonly"])
              ]),
              _: 1
            }, 8, ["cols"]),
            _createVNode(_component_v_col, {
              cols: _ctx.sepas.length ? 4 : 6,
              class: "pl-2 mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_oss_date_picker_filled, {
                  modelValue: _ctx.selectedSepa.date,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSepa.date) = $event)),
                  label: "Date",
                  textFieldReadOnly: false,
                  mandatory: true,
                  "hide-details": "auto",
                  readonly: _ctx.readonly
                }, null, 8, ["modelValue", "readonly"])
              ]),
              _: 1
            }, 8, ["cols"]),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.company.name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.company.name) = $event)),
                  label: "Nom de la société",
                  "hide-details": "",
                  rules: [_ctx.rules.notEmpty],
                  readonly: "",
                  density: "compact"
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "6",
              class: "pl-2 mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field_filled, {
                  modelValue: _ctx.company.siret,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.siret) = $event)),
                  label: "Siret",
                  onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputSetTruncatedSiret(_ctx.company.siret))),
                  "hide-details": "",
                  rules: [_ctx.rules.notEmpty, _ctx.rules.checkSiret],
                  readonly: "",
                  density: "compact"
                }, null, 8, ["modelValue", "rules"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: _ctx.type === 'directDebit' ? 6 : 4,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select_filled, {
                  modelValue: _ctx.bankAccountId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bankAccountId) = $event)),
                  items: _ctx.bankAccounts,
                  "item-value": "id",
                  label: _ctx.type === 'directDebit' ? 'Compte à créditer' : 'Compte à débiter',
                  mandatory: true,
                  "hide-details": "auto",
                  rules: [(v) => !!v || 'Compte bancaire requis'],
                  readonly: _ctx.readonly,
                  density: "compact",
                  "item-title": (item) => item.name
                }, null, 8, ["modelValue", "items", "label", "rules", "readonly", "item-title"])
              ]),
              _: 1
            }, 8, ["cols"]),
            (_ctx.bankAccount)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: _ctx.type === 'directDebit' ? 6 : 4,
                  class: "pl-2 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.bankAccount.iban,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bankAccount.iban) = $event)),
                      label: "IBAN",
                      outlined: "",
                      rules: [_ctx.rules.notEmpty, _ctx.rules.checkIBAN],
                      onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onIbanChanged(_ctx.bankAccount))),
                      onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onInputSetTruncatedIban(_ctx.bankAccount.iban))),
                      readonly: _ctx.readonly,
                      density: "compact"
                    }, null, 8, ["modelValue", "rules", "readonly"])
                  ]),
                  _: 1
                }, 8, ["cols"]))
              : _createCommentVNode("", true),
            (_ctx.bankAccount)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: _ctx.type === 'directDebit' ? 6 : 4,
                  class: _normalizeClass(_ctx.type === 'directDebit' ? 'mt-2' : 'pl-2 mt-2')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.bankAccount.bic,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bankAccount.bic) = $event)),
                      label: "BIC",
                      outlined: "",
                      rules: [_ctx.rules.notEmpty, _ctx.rules.checkBIC],
                      readonly: _ctx.readonly,
                      density: "compact"
                    }, null, 8, ["modelValue", "rules", "readonly"])
                  ]),
                  _: 1
                }, 8, ["cols", "class"]))
              : _createCommentVNode("", true),
            (_ctx.bankAccount && _ctx.type === 'directDebit')
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 3,
                  cols: "6",
                  class: "pl-2 mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field_filled, {
                      modelValue: _ctx.bankAccount.creditorIdentifier,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bankAccount.creditorIdentifier) = $event)),
                      label: "ICS",
                      outlined: "",
                      rules: [_ctx.rules.notEmpty, _ctx.rules.checkICS],
                      readonly: _ctx.readonly,
                      density: "compact"
                    }, null, 8, ["modelValue", "rules", "readonly"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.transactions.length)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              style: {"border":"1px #ededed solid","border-radius":"15px"},
              class: "mt-2 pa-2",
              "no-gutters": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_oss_data_table, {
                      items: _ctx.transactions,
                      headers: _ctx.headers,
                      "show-select": false
                    }, {
                      item: _withCtx((props) => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(props.item.reason), 1),
                          _createElementVNode("td", null, _toDisplayString(props.item.thirdParty), 1),
                          _createElementVNode("td", null, [
                            (props.item.bankAccount)
                              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                  key: 0,
                                  modelValue: props.item.bankAccount.iban,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.bankAccount.iban) = $event),
                                  placeholder: "IBAN",
                                  "hide-details": "auto",
                                  rules: [_ctx.rules.notEmpty, _ctx.rules.checkIBAN],
                                  onChange: ($event: any) => (_ctx.onIbanChanged(props.item.bankAccount)),
                                  readonly: _ctx.readonly,
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "onChange", "readonly"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (props.item.bankAccount)
                              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                  key: 0,
                                  modelValue: props.item.bankAccount.bic,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.bankAccount.bic) = $event),
                                  placeholder: "BIC",
                                  "hide-details": "auto",
                                  rules: [_ctx.rules.notEmpty, _ctx.rules.checkBIC],
                                  readonly: _ctx.readonly,
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "readonly"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.type === 'directDebit')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                                (
                                            props.item.bankAccount && props.item.bankAccount.mandate
                                        )
                                  ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                      key: 0,
                                      modelValue: props.item.bankAccount.mandate.id,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.bankAccount.mandate.id) = $event),
                                      placeholder: "RUM",
                                      "hide-details": "auto",
                                      rules: [_ctx.rules.notEmpty],
                                      readonly: _ctx.readonly,
                                      density: "compact"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "readonly"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.type === 'directDebit')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
                                (
                                            props.item.bankAccount && props.item.bankAccount.mandate
                                        )
                                  ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                      key: 0,
                                      modelValue: props.item.bankAccount.mandate.date,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.bankAccount.mandate.date) = $event),
                                      "hide-details": "",
                                      textFieldReadOnly: false,
                                      outlined: false,
                                      "no-menu": true,
                                      readonly: _ctx.readonly
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            _createVNode(_component_oss_text_field, {
                              modelValue: props.item.paymentAmount,
                              "onUpdate:modelValue": ($event: any) => ((props.item.paymentAmount) = $event),
                              suffix: "€",
                              placeholder: "Montant",
                              dense: "",
                              "single-line": "",
                              outlined: false,
                              "hide-details": "auto",
                              readonly: _ctx.readonly,
                              rules: [
                                            (v) =>
                                                (!!v && parseFloat(v) > 0) ||
                                                _ctx.$t('settings.positiveNumber'),
                                        ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "rules"])
                          ]),
                          _createElementVNode("td", _hoisted_3, [
                            _createVNode(_component_v_btn_trash, {
                              onClick: ($event: any) => (_ctx.removeTransaction(props.item)),
                              disabled: _ctx.readonly
                            }, null, 8, ["onClick", "disabled"])
                          ])
                        ])
                      ]),
                      "body.append": _withCtx(() => [
                        _createElementVNode("tr", _hoisted_4, [
                          _createElementVNode("td", {
                            class: "text-right",
                            colspan: _ctx.type === 'directDebit' ? 6 : 4
                          }, _cache[15] || (_cache[15] = [
                            _createElementVNode("strong", null, "Total", -1)
                          ]), 8, _hoisted_5),
                          _createElementVNode("td", _hoisted_6, [
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.total, undefined)), 1)
                            ])
                          ]),
                          _cache[16] || (_cache[16] = _createElementVNode("td", null, null, -1))
                        ])
                      ]),
                      _: 1
                    }, 8, ["items", "headers"])
                  ]),
                  _: 1
                }),
                (_ctx.mode === 'Embedded')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "d-flex justify-end align-center py-3"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.validated)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              size: "small",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateSepa())),
                              loading: _ctx.loading,
                              disabled: !_ctx.globalValid
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("Modifier")
                              ])),
                              _: 1
                            }, 8, ["loading", "disabled"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_btn, {
                          size: "small",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateSepa('VALIDATED'))),
                          class: "ml-2",
                          loading: _ctx.loading,
                          disabled: !_ctx.globalValid || _ctx.readonly
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.validated ? "Validé" : "Valider"), 1),
                            _withDirectives(_createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("$check")
                              ])),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.validated]
                            ])
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}